import React from 'react'
import PropTypes from 'prop-types'
import * as S from './ButtonTransparent.styled'
import { ThemeColors } from 'src/shared/ui/consts-styles'
import { ElementSizeType } from '@styles/theme-const'

const init = {
    colors: {
        color: ThemeColors.accentGreen,
        hoverColor: ThemeColors.accentGreenLight
    },
    options: {
        isBold: true
    }
}
const ButtonTransparent = ({
    clickHandler,
    children,
    isClickable = true,
    isVisible = true,
    colors = init.colors,
    options = init.options,
    elementSizeTypeValue = ElementSizeType.regular,
    ...props
}) => {
    colors = { ...colors, ...init.colors }
    return (
        <S.ButtonElement
            onClick={clickHandler}
            isClickable={isClickable}
            isVisible={isVisible}
            colors={colors}
            options={options}
            {...props}>
            {children}
        </S.ButtonElement>
    )
}

ButtonTransparent.propTypes = {
    isClickable: PropTypes.bool,
    elementSizeTypeValue: PropTypes.string,
    isVisible: PropTypes.bool,
    children: PropTypes.any.isRequired,
    colors: PropTypes.shape({
        color: PropTypes.string.isRequired,
        hoverColor: PropTypes.string
    }),
    options: PropTypes.shape({
        isBold: PropTypes.bool.isRequired
    }),
    clickHandler: PropTypes.func.isRequired
}

export default ButtonTransparent
